module.exports = __webpack_public_path__ + "img/upload.dc08c3cc.svg";